import { render, staticRenderFns } from "./UsersReport.vue?vue&type=template&id=78f2f928"
import script from "./UsersReport.vue?vue&type=script&lang=js"
export * from "./UsersReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports